var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _rect, _path49, _path50;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfettiSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 41.1758C92.1228 40.1936 91.9825 39.4218 90.7196 38.8605C89.597 38.1589 89.5268 37.3871 90.5091 36.5452C91.4914 35.5629 91.351 34.7912 90.0881 34.2299C88.9656 33.6686 88.8954 32.8968 89.8776 31.9146",
    stroke: "#8266FF",
    strokeWidth: 0.841934,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.976 48.9634C118.854 49.3843 118.854 49.8755 119.976 50.4368C121.099 50.8577 121.099 51.2787 119.976 51.6997C118.854 52.1206 118.854 52.6118 119.976 53.173C121.099 53.594 121.099 54.015 119.976 54.436",
    stroke: "#BDFF66",
    strokeWidth: 0.631451,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4707 44.5432L13.4715 43.4907L15.7868 40.3335L17.4707 44.5432Z",
    fill: "#FF66BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9901 53.9097C46.8675 54.3306 46.8675 54.7516 47.9901 55.1726C49.1127 55.5935 49.1127 56.0847 47.9901 56.646C46.8675 57.0669 46.8675 57.4879 47.9901 57.9089C49.1127 58.3298 49.1127 58.7508 47.9901 59.1718",
    stroke: "#9466FF",
    strokeWidth: 0.631451,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.508 29.3886L95.1395 27.0732L99.1387 28.3361L98.5072 30.6515L94.508 29.3886Z",
    fill: "#FCFF66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.836 16.3386C34.9763 17.6015 35.3271 17.6716 35.8884 16.5491C36.59 15.7071 36.9408 15.8474 36.9408 16.97C36.9408 18.0926 37.2215 18.1628 37.7827 17.1805C38.6247 16.1983 38.9755 16.3386 38.8352 17.6015",
    stroke: "#7366FF",
    strokeWidth: 0.631451,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78894 63.4868L1.26314 71.0642",
    stroke: "#9166FF",
    strokeWidth: 0.631451,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0463 102.005L40.4141 99.4795",
    stroke: "#66FFB2",
    strokeWidth: 0.841934,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3976 31.5987L59.104 30.652L59.0253 29.1217L57.9208 30.1629L56.2801 29.7841L57.0215 31.2513L56.1221 32.3398L57.6525 32.2611L58.4412 33.5233L58.9777 32.135L60.3976 31.5987Z",
    fill: "#66FFB2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0764 26.1229L49.7224 25.0461L50.258 24.0471L49.2072 24.1046L48.5307 23.2984L48.1304 24.4586L47.0536 24.8126L48.0525 25.3482L48.2453 26.5603L49.0515 25.8838L50.0764 26.1229Z",
    fill: "#EDFF66"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3665 33.363L28.6923 34.264L28.8244 35.7907L29.8918 34.7116L31.5448 35.0329L30.7527 33.5924L31.6536 32.2666L30.0868 32.6053L29.0479 31.3312L28.7668 32.7775L27.3665 33.363Z",
    fill: "#DBFF66"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95378 117.114L10.4991 115.507L11.9053 115.019L10.6312 113.98L10.5165 112.287L9.23086 113.395L7.6239 112.849L8.15181 114.462L7.35971 115.903L8.84618 115.828L9.95378 117.114Z",
    fill: "#FF8F66"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.875 92.5337L92.6121 101.374",
    stroke: "#6682FF",
    strokeWidth: 0.841934,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.767 17.6015C108.929 17.6015 109.872 17.0361 109.872 16.3386C109.872 15.6411 108.929 15.0757 107.767 15.0757C106.604 15.0757 105.662 15.6411 105.662 16.3386C105.662 17.0361 106.604 17.6015 107.767 17.6015Z",
    fill: "#FF66DB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4634 110.26C85.3519 111.533 86.1065 112.64 87.1487 112.731C88.191 112.822 89.1262 111.864 89.2377 110.59C89.3491 109.316 88.5946 108.209 87.5523 108.118C86.5101 108.027 85.5748 108.986 85.4634 110.26Z",
    fill: "#66CFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0.880591 80.0258C1.08979 80.9319 1.90213 81.5181 2.695 81.335C3.48787 81.152 3.96103 80.269 3.75183 79.3629C3.54264 78.4567 2.7303 77.8706 1.93742 78.0536C1.14455 78.2367 0.671392 79.1196 0.880591 80.0258Z",
    fill: "#FFC266"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M116.086 22.6579L115.593 23.46L114.755 23.3866L115.329 24.0707L115.255 24.9094L115.921 24.5451L116.723 25.0378L116.587 24.1807L117.271 23.6067L116.432 23.5333L116.086 22.6579Z",
    fill: "#DB66FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.293 80.8518C113.275 79.8695 113.135 79.0276 111.872 78.326C110.749 77.6244 110.609 76.7123 111.451 75.5897C112.574 74.6074 112.503 73.7655 111.24 73.0639C109.978 72.5026 109.837 71.6607 110.82 70.5381",
    stroke: "#BF66FF",
    strokeWidth: 0.631451,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3535 16.9701L69.6713 14.8652",
    stroke: "#66A1FF",
    strokeWidth: 0.841934,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.204 41.2808C33.3621 42.4033 33.5725 43.1751 34.8354 43.5961C36.0983 44.017 36.3088 44.7888 35.4669 45.9114C34.625 46.8937 34.9056 47.6654 36.3088 48.2267C37.5717 48.5074 37.7822 49.209 36.9403 50.3316",
    stroke: "#FF66D6",
    strokeWidth: 0.631451,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5156 74.4321L50.0947 79.4837",
    stroke: "#FF66F2",
    strokeWidth: 0.841934,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 62.645L122.08 65.5918",
    stroke: "#9966FF",
    strokeWidth: 0.841934,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.242 94.9871C64.1885 94.4959 63.0556 94.6955 62.7117 95.4329C62.3678 96.1704 62.9431 97.1665 63.9967 97.6578C65.0502 98.1491 66.1831 97.9495 66.527 97.212C66.8709 96.4745 66.2956 95.4784 65.242 94.9871Z",
    fill: "#EDFF66"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5117 39.2812L64.1972 44.7538",
    stroke: "#FF66F7",
    strokeWidth: 0.631451,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M103.368 114.219L103.863 113.538L104.791 113.693L104.357 112.857L104.852 112.176L103.97 112.316L103.289 111.821L103.259 112.579L102.423 113.013L103.228 113.337L103.368 114.219Z",
    fill: "#A666FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.463 59.3846C19.8379 60.3613 20.7577 60.9167 21.5174 60.6251C22.2771 60.3335 22.589 59.3053 22.214 58.3286C21.8391 57.3519 20.9193 56.7965 20.1596 57.0881C19.4 57.3797 19.0881 58.4079 19.463 59.3846Z",
    fill: "#D466FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9167 68.1462L59.4058 66.9169L60.2209 65.9295L58.8742 65.9846L58.2046 64.8933L57.9626 66.2192L56.5953 66.5712L57.7415 67.2481L57.6584 68.4359L58.7497 67.7662L59.9167 68.1462Z",
    fill: "#66FFF0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2989 18.2329L91.7715 26.6523",
    stroke: "#A166FF",
    strokeWidth: 0.841934,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9437 78.9086L72.1749 79.7712L71.7539 80.5003L72.5112 80.4515L73.0299 81.237L73.2686 80.4026L74.1311 80.1715L73.402 79.7505L73.4584 78.8109L72.6729 79.3295L71.9437 78.9086Z",
    fill: "#66FFEB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4767 87.5361L57.9889 86.8046L58.8181 86.6584L58.2939 86.1097L58.5622 85.2074L57.7696 85.5609L57.0381 85.0487L57.1843 85.8778L56.4283 86.4386L57.3305 86.707L57.4767 87.5361Z",
    fill: "#66FF73"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.067 101.596C20.6084 100.656 19.4743 100.265 18.534 100.724C17.5936 101.182 17.2031 102.317 17.6618 103.257C18.1204 104.197 19.2545 104.588 20.1948 104.129C21.1352 103.67 21.5257 102.536 21.067 101.596Z",
    fill: "#6E66FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3493 45.5957L101.033 46.8586L98.7179 47.2796L99.3493 45.5957Z",
    fill: "#A166FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8751 14.0232L92.8235 6.4458",
    stroke: "#FF6E66",
    strokeWidth: 0.841934,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M100.401 90.6392L98.0858 87.9029L101.664 87.2715L100.401 90.6392Z",
    fill: "#FF6696"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8719 96.6851L78.8416 97.0941L79.0453 97.9111L79.7095 97.0947L80.6282 97.2995L79.9652 96.3802L80.4251 95.6147L79.6082 95.8184L78.7918 95.1542L78.638 96.2772L77.8719 96.6851Z",
    fill: "#FF66C7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5161 107.899L54.7266 111.056L51.7798 109.372L54.5161 107.899Z",
    fill: "#E3FF66"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0043 83.5719C18.4655 82.6752 17.6248 82.1908 17.1266 82.4902C16.6283 82.7896 16.6613 83.7592 17.2001 84.656C17.739 85.5528 18.5797 86.0371 19.0779 85.7378C19.5761 85.4384 19.5432 84.4687 19.0043 83.5719Z",
    fill: "#8CFF66"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0018 63.0836L96.0541 63.0996L96.7964 64.1213L97.1064 63.1156L98.2052 62.8376L97.4163 62.1099L97.4323 61.0576L96.5809 61.6762L95.6217 61.0722L95.7295 62.2948L95.0018 63.0836Z",
    fill: "#FF66D6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7698 74.8528L99.1375 73.3794L100.4 75.9052L96.8222 77.3786L95.7698 74.8528Z",
    fill: "#9466FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.502 7.49827C123.379 6.79665 122.818 7.14746 122.818 8.55068C122.958 9.81359 122.537 10.0942 121.555 9.39262C120.433 8.83133 119.871 9.18214 119.871 10.445C120.012 11.7079 119.521 11.9886 118.398 11.287",
    stroke: "#8A66FF",
    strokeWidth: 0.631451,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4646 13.8127L42.0961 9.81348L45.8848 10.4449L45.2533 14.4441L41.4646 13.8127Z",
    fill: "#FC66FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4203 84.5915L39.8281 85.2258L38.9897 85.0018L39.3378 85.6761L38.9297 86.4125L39.686 86.3504L40.3204 86.9427L40.4424 86.2884L41.2188 85.7561L40.4824 85.3479L40.4203 84.5915Z",
    fill: "#69FF66"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9874 14.6548L62.3027 15.9177L59.5664 16.9701L59.9874 14.6548Z",
    fill: "#FCFF66"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9127 93.1396C46.3373 93.7149 46.0708 94.3813 46.3174 94.6279C46.5639 94.8745 47.2303 94.608 47.8057 94.0326C48.3811 93.4572 48.6476 92.7908 48.401 92.5442C48.1544 92.2976 47.4881 92.5642 46.9127 93.1396Z",
    fill: "#66C4FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00843 97.7479L9.15954 97.0469L10.2743 97.6766L9.84308 96.3997L10.8684 95.4289L9.53766 95.3926L9.03446 94.3135L8.40474 95.4282L7.27181 95.4638L8.24258 96.4891L8.00843 97.7479Z",
    fill: "#668CFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M118.082 108.109L115.977 98.8481",
    stroke: "#6678FF",
    strokeWidth: 0.631451,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5237 53.1731L9.05111 56.5408",
    stroke: "#FF66F0",
    strokeWidth: 0.841934,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15702 37.8079L1.26267 36.124L4.41992 36.124L3.15702 37.8079Z",
    fill: "#FF7A66"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0654 69.056C32.4212 68.2316 31.2307 68.0854 30.4063 68.7295C29.5819 69.3736 29.4357 70.5641 30.0798 71.3886C30.7239 72.213 31.9144 72.3592 32.7389 71.7151C33.5633 71.0709 33.7095 69.8805 33.0654 69.056Z",
    fill: "#FF66C4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M22.652 11.4694L21.4266 12.5653L19.7364 12.4137L20.6293 13.8568L19.8393 15.3587L21.5148 15.0895L22.8136 16.0972L22.9725 14.6174L24.4157 13.7246L22.9138 12.9346L22.652 11.4694Z",
    fill: "#FF9666"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.9999,
    height: 40,
    transform: "translate(42.5137 42.0918)",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5143 45.4253C53.331 45.4253 45.8477 52.9086 45.8477 62.092C45.8477 71.2753 53.331 78.7586 62.5143 78.7586C71.6976 78.7586 79.1809 71.2753 79.1809 62.092C79.1809 52.9086 71.6976 45.4253 62.5143 45.4253ZM70.4809 58.2586L61.0309 67.7086C60.7976 67.942 60.4809 68.0753 60.1476 68.0753C59.8143 68.0753 59.4976 67.942 59.2643 67.7086L54.5476 62.992C54.0643 62.5086 54.0643 61.7086 54.5476 61.2253C55.031 60.742 55.831 60.742 56.3143 61.2253L60.1476 65.0586L68.7142 56.492C69.1976 56.0086 69.9976 56.0086 70.4809 56.492C70.9642 56.9753 70.9642 57.7586 70.4809 58.2586Z",
    fill: "#11A811"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80C52.0589 80 44 71.9411 44 62C44 52.0589 52.0589 44 62 44H63C72.9411 44 81 52.0589 81 62C81 71.9411 72.9411 80 63 80H62Z",
    stroke: "#DCFDDB",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiSuccess);
export default __webpack_public_path__ + "static/media/confetti-success.f425130570e4a454d16f0670fddf11ab.svg";
export { ForwardRef as ReactComponent };